import React from 'react';
import styles from './ProductCard.module.scss';

/**
 * Product card component
 * Displays a single product with image, title, and description
 *
 * @param {Object} props
 * @param {Object} props.product - Product data
 */
export default function ProductCard({ product }) {
    console.log(product);
    return (
        <article className={styles.product}>
            <div className={styles.imageContainer}>
                {product.categoryLabels && product.categoryLabels.length > 0 && (
                    <div className={styles.categoryPill}>
                        {product.categoryLabels[0].title}
                    </div>
                )}
                {product.image ? (
                    <img
                        src={product.image}
                        alt={product.title}
                        loading="lazy"
                        className={styles.image}
                    />
                ) : (
                    <div style={{
                        backgroundColor: '#f0f0f0',
                        aspectRatio: '1/1',
                        width: '100%'
                    }} />
                )}
            </div>
            <div className={styles.content}>
                {product.latin_name && (
                    <div className={styles.latinName}>{product.latin_name}</div>
                )}
                <h3 className={styles.title}>{product.title}</h3>
                {product.description && (
                    <div
                        className={styles.description}
                        dangerouslySetInnerHTML={{ __html: product.description }}
                    />
                )}
                <div className={styles.spacer}></div>
                <div className={styles.priceAndButton}>
                    <a href={product.url} className={styles.link}>zum Produkt</a>
                </div>
            </div>
        </article>
    );
}
